import React, { Component } from 'react'
import { connect } from 'react-redux'
import authSelector from '../../../selectors/authSelector'
import Splitter from '../../../helpers/Splitter'

const StudentPurchaseEventPage = Splitter(() =>
  import('../../student/StudentPurchaseEventPage')
)
const SchoolPurchaseEventPage = Splitter(() =>
  import('../../school/SchoolPurchaseEventPage')
)

class EventPurchaseContainer extends Component {
  render() {
    const { userType, params: { eventId, eventCode } } = this.props
    if (userType === 'STUDENT') {
      return <StudentPurchaseEventPage eventId={eventId} eventCode={eventCode} />
    } else if (userType === 'SCHOOL') {
      return <SchoolPurchaseEventPage eventId={eventId} eventCode={eventCode} />
    } else {
      return <div />
    }
  }
}

export default connect(authSelector)(EventPurchaseContainer)



// WEBPACK FOOTER //
// ./src/components/common/events/EventPurchaseContainer.js